import { render, staticRenderFns } from "./PostEnquirySettingsComponent.vue?vue&type=template&id=4c4b52e2"
import script from "./PostEnquirySettingsComponent.vue?vue&type=script&lang=ts"
export * from "./PostEnquirySettingsComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports